<chapps-tab-group [title]="Localization.Notifications | translate">
  <!-- Open Notifications -->
  <chapps-tab [label]="Localization.OpenNotificationsTab | translate"
              (activated)="showOpenNotifications()">
    <ng-container *ngTemplateOutlet="LegacyListView"></ng-container>
  </chapps-tab>
  <!--  Latest Notifications -->
  <chapps-tab [label]="Localization.Latest | translate"
              (activated)="showLatestNotifications()">
    <ng-container *ngTemplateOutlet="LegacyListView"></ng-container>
  </chapps-tab>

  <section tab-header-postfix>
    <chapps-primary-button [small]="true"
                           [icon]="'fa-eye'"
                           [label]="Localization.SeeMore | translate"
                           [outline]="true"
                           (clicked)="goToNotificationsPage()">
    </chapps-primary-button>
  </section>
</chapps-tab-group>

<ng-template #LegacyListView>
  <div *ngIf="isLoading" class="flex-center m-4">
    <mdb-spinner spinnerColor="blue"></mdb-spinner>
  </div>
  <div *ngIf="isListEmpty() && !isLoading" class="alert alert-light m-4" role="alert">
    {{ Localization.EmptyDataMessage | translate }}
  </div>
  <table *ngIf="!isListEmpty() && !isLoading" mdbTable
         class="details-table table-with-actions table-no-first-border mb-0"
         [striped]="true" [hover]="true">
    <thead>
    <tr>
      <th>
        {{Localization.PlaceAndDescription | translate}}
      </th>
      <th>{{Localization.Reported | translate}}</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr mdbTableCol *ngFor="let item of list" class="clickable" (click)="goToNotificationDetailsPage(item)">
      <td class="p-0"
          colspan="2">
        <app-notification-list-item [model]="item" (clicked)="goToNotificationDetailsPage(item)">
        </app-notification-list-item>
      </td>
      <td class="text-center align-middle move-right-animation">
        <i class="fas fa-angle-right fa-lg"></i>
      </td>
    </tr>
    </tbody>
  </table>
</ng-template>
